/* eslint-disable */
import $ from 'jquery';
import BaseModel from '@bingads-webui-campaign-legacy/bulk-operation/util/bulk-edit-job';
var model = BaseModel.extend({
  defaults: $.extend({}, BaseModel.prototype.defaults, {
    'BatchAction': {
      'Actions': [{
        '@data.type': '#Model.LabelAssociationAction',
        'AssociationList': []
      }]
    },
    'Entity': '',
    'RequestProperties': [],
    'CurrentCustomerId': ''
  })
});
export default model;

